import React, { useEffect, useState } from 'react';
import { siteService } from '../services/api';

export default function Hero({ onCTAClick }) {
  const [site, setSite] = useState(null);
  
  useEffect(() => {
    const loadSiteInfo = async () => {
      try {
        const response = await siteService.getSite();
        setSite(response.data.site);
      } catch (error) {
        console.error('Error loading site info:', error);
      }
    };

    loadSiteInfo();
  }, []);

  if (!site) return null;

  return (
    <section className='bg-white'>
      <div className='max-w-6xl mx-auto px-4 py-10 md:py-16'>
        <div className='grid grid-cols-1 md:grid-cols-2 items-center gap-8'>
          <div>
            <h1 className='text-3xl md:text-5xl font-extrabold leading-tight'>
              <span className="block">{site.party}</span>
              <span className="block">{site.location}</span>
            </h1>
            <p className='mt-4 text-gray-700 max-w-xl'>{site.slogan}</p>
          </div>
          <div className="rounded-md h-64 md:h-80 overflow-hidden shadow">
            {site.bannerSignedUrl || site.bannerUrl ? (
              <img
                src={"https://noemibejaranoaparicio.com/DARWIN_NOEMI_2026.jpeg"}
                alt="Banner principal"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="rounded-md h-64 md:h-80 overflow-hidden shadow">
                {site.bannerSignedUrl || site.bannerUrl ? (
                  <img
                    src={"https://noemibejaranoaparicio.com/DARWIN_NOEMI_2026.jpeg"}
                    alt="Banner principal"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="h-full flex items-center justify-center text-gray-400">
                    [Imagen/Video del equipo o actividad]
                  </div>
                )}
              </div>

            )}
          </div>
        </div>
      </div>
    </section>
  );
}
